export default __webpack_public_path__ + "static/media/icon-fuel.d0df51de.svg";